@if (displayName()) {
<button mat-icon-button [matMenuTriggerFor]="menu" [matTooltip]="displayName()" class="initials">
    {{initials()}}
</button>
}

<mat-menu #menu="matMenu" xPosition="before">
    @if (displayName()) {
    <button mat-menu-item (click)="logout()" color="warn">
        <mat-icon>exit_to_app</mat-icon> {{ 'app.logout' | translate }} {{ displayName() }}
    </button>
    }
</mat-menu>